module.exports = __webpack_public_path__ + "static/img/product4.bb3f1276.png";